import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [RouterOutlet],
  selector: 'norupe-root',
  styleUrl: './app.component.css',
  template: `<router-outlet />`,
})
export class AppComponent {
  title = 'frontend';
}
